var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 14.9997L12.381 9.99967M7.61913 9.99967L2.08344 14.9997M1.66675 5.83301L8.47085 10.5959C9.02182 10.9816 9.29731 11.1744 9.59697 11.2491C9.86166 11.3151 10.1385 11.3151 10.4032 11.2491C10.7029 11.1744 10.9783 10.9816 11.5293 10.5959L18.3334 5.83301M5.66675 16.6663H14.3334C15.7335 16.6663 16.4336 16.6663 16.9684 16.3939C17.4388 16.1542 17.8212 15.7717 18.0609 15.3013C18.3334 14.7665 18.3334 14.0665 18.3334 12.6663V7.33301C18.3334 5.93288 18.3334 5.23281 18.0609 4.69803C17.8212 4.22763 17.4388 3.84517 16.9684 3.60549C16.4336 3.33301 15.7335 3.33301 14.3334 3.33301H5.66675C4.26662 3.33301 3.56655 3.33301 3.03177 3.60549C2.56137 3.84517 2.17892 4.22763 1.93923 4.69803C1.66675 5.23281 1.66675 5.93288 1.66675 7.33301V12.6663C1.66675 14.0665 1.66675 14.7665 1.93923 15.3013C2.17892 15.7717 2.56137 16.1542 3.03177 16.3939C3.56655 16.6663 4.26662 16.6663 5.66675 16.6663Z",
    stroke: "#30893C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d1564cde513e8a56f8a6e80e324a4186.svg";
export { ForwardRef as ReactComponent };